/**
 * Constants shared by the activity-report store module and page. Kept
 * dependency-free so the page can import them without pulling the store
 * (and its `~services` → `~store` cycle) into unit tests.
 */
export const DATE_FORMAT = 'YYYY-MM-DD';

/** Sentinel for the "All businesses" option (v-select does not like `null`). */
export const ALL_BUSINESSES = '';

/**
 * Quick date-range presets. Every preset returns inclusive `YYYY-MM-DD`
 * bounds; `today` (a dayjs instance) is injectable for deterministic tests.
 */
export const PRESETS = {
    last7: today => ({
        dateFrom: today.subtract(6, 'day').format(DATE_FORMAT),
        dateTo: today.format(DATE_FORMAT)
    }),
    last30: today => ({
        dateFrom: today.subtract(29, 'day').format(DATE_FORMAT),
        dateTo: today.format(DATE_FORMAT)
    }),
    thisMonth: today => ({
        dateFrom: today.startOf('month').format(DATE_FORMAT),
        dateTo: today.format(DATE_FORMAT)
    }),
    lastMonth: today => {
        const month = today.subtract(1, 'month');
        return {
            dateFrom: month.startOf('month').format(DATE_FORMAT),
            dateTo: month.endOf('month').format(DATE_FORMAT)
        };
    }
};
